<template>
  <v-container fluid>
    <v-snackbar v-model="snackbar" color="accent"><v-icon color="white" left>{{snackbarIcon}}</v-icon>{{snackbarText}}</v-snackbar>
    <v-layout>
      <v-flex>
        <p v-if="jobs.length === 0">Outbox is empty</p>
        <template v-else>
          <v-card class="my-2" v-for="job in jobs" :key="job.number">
            <v-container fluid>
              <v-layout row wrap>
                  <h3>{{ job.JobNo }}</h3>
              </v-layout>
              <v-layout row wrap>
                  <h5 class="subheading">{{ job.Customer | customerNameFromId(customers) }} {{imageCount(job).sent}}/{{imageCount(job).count}} images sent</h5>
              </v-layout>
              <v-layout row align-center justify-space-around>
                <!-- <v-btn icon @click="emailJob(job.number)">
                  <v-icon color="grey">email</v-icon>
                </v-btn> -->
                <v-btn icon @click="downloadJob(job.number)">
                  <v-icon color="blue">file_download</v-icon>
                </v-btn>
                <v-btn icon @click="uploadJob(job.number)">
                  <v-icon color="green">file_upload</v-icon>
                </v-btn>
                <v-btn icon @click="deleteJob(job.number)">
                  <v-icon color="error">delete</v-icon>
                </v-btn>
              </v-layout>
            </v-container>
          </v-card>
        </template>
      </v-flex>
    </v-layout>
    <v-dialog v-model="logDialog">
      <v-card>
        <v-card-title>{{ logDialogTitle }}</v-card-title>
        <v-card-text>
          <v-layout row justify-end>
            <v-btn small flat @click="copyLog">Copy</v-btn>
            <v-btn small flat @click="sendDebugLog">Send Log</v-btn>
          </v-layout>
          <v-textarea v-model="logDialogLog" rows="10" label="Log" ref="logTextField" class="pt-0" autofocus></v-textarea>
          <p>{{logDialogInfo}}</p>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-end>
            <v-btn @click="logDialog = false" color="grey darken-2" flat>Close</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import dbPromise from '../dbPromise'
import { storage, fireStore } from '../firebase'
import moment from 'moment'
import saveAs from 'file-saver'
import JsZip from 'jszip'
export default {
  data () {
    return {
      jobs: [],
      customers: [],
      logDialog: false,
      logDialogTitle: null,
      logDialogLog: null,
      logDialogInfo: null,
      snackbar: false,
      snackbarText: '',
      snackbarIcon: ''
    }
  },
  created () {
    this.getJobs()
    this.getCustomers()
  },
  filters: {
    customerNameFromId (customerId, customers) {
      const customerObj = customers.find(customer => {
        return customerId === customer.id
      })
      return customerObj ? customerObj.customerName : ''
    }
  },
  methods: {
    getJobs () {
      this.jobs = []
      dbPromise().then(db => {
        let tx = db.transaction('outbox')
        let outboxStore = tx.objectStore('outbox')
        return (outboxStore.getAllKeys())
      }).then((keys) => {
        if (keys.length > 0) {
          keys.forEach(element => {
            dbPromise().then(db => {
              return db.transaction('outbox').objectStore('outbox').get(element)
            }).then((val) => {
              val.element = element
              this.jobs.push(val)
            })
          })
        }
      })
    },
    getCustomers () {
      this.customers = []
      fireStore.collection('Customers').get()
      .then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.customers.push(data)
        })
      })
    },
    copyLog () {
      this.$copyText(this.logDialogLog).then(e => {
        this.snackbarIcon = 'file_copy'
        this.snackbarText = 'Log data copied to clipboard'
        this.snackbar = true
      })
      .catch(e => {
        console.log(e)
      })
    },
    emailJob (jobNumber) {
    },
    downloadJob (jobNumber) {
      this.logDialogTitle = 'Download Job'
      this.logDialogInfo = 'Download starting'
      this.logDialogLog = ''
      this.logDialog = true
      this.generateZip(jobNumber, (content, zipName) => {
        this.logDialogLog += 'Zip file generated, downloading now\n'
        saveAs(content, zipName + '.zip')
        this.logDialogInfo = 'Download complete'
        this.logDialogLog += 'Download complete\n'
      })
    },
    sendDebugLog () {
      fireStore.collection('debug').add({data: this.logDialogLog})
      .then((snap) => {
        alert('Log Sent, ref: ' + snap.id)
      })
    },
    uploadJob (jobNumber) {
      this.logDialogTitle = 'Upload Job'
      this.logDialogInfo = 'Upload in progress'
      this.logDialogLog = ''
      this.logDialog = true

      let jobIndex = this.jobs.findIndex(jobObj => { return jobObj.number === jobNumber })
      let job = this.jobs[jobIndex]
      let jobNumbers = []
      const customerIndex = this.customers.findIndex(customer => {
        return job.Customer === customer.id
      })
      const shortName = this.customers[customerIndex]['shortName']

      fireStore.collection('Jobs').where('Customer', '==', job.Customer).get()
      .then(async snap => {
        snap.forEach(doc => {
          let JobNo = doc.data().JobNo
          if (JobNo && JobNo.indexOf(shortName) > -1) { // This check is needed in case the short name has been changed. We only want to increment on job numbers with the new short name.
            JobNo = JobNo.replace(/\D/g, '')
            jobNumbers.push(JobNo)
          }
        })
        jobNumbers.sort((a, b) => {
          return b - a
        })
        if (!job.JobNo) {
          job.JobNo = shortName + this.zeroFill(parseInt(jobNumbers[0]) + 1, 4)
          this.logDialogLog += 'Job number not found, set to ' + job.JobNo + '\n'
        } else {
          this.logDialogLog += 'Job number = ' + job.JobNo + '\n'
        }
        if (!job.unscheduled) {
          job.unscheduled = 0
          this.logDialogLog += 'Job is scheduled\n'
        } else {
          this.logDialogLog += 'Job is unscheduled\n'
        }
        if (!job.Date) {
          job.Date = moment().format('YYYY-MM-DD')
          this.logDialogLog += 'Job date not found, set to ' + job.Date + '\n'
        } else {
          this.logDialogLog += 'Job date = ' + job.Date + '\n'
        }
        if (job.vehicle === undefined || job.vehicle === '' || job.vehicle === null) {
          job.vehicle = job.reg
          this.logDialogLog += 'vehicle not found, set to ' + job.vehicle + '\n'
        } else {
          this.logDialogLog += 'vehicle not = ' + job.vehicle + '\n'
        }
        if (job.imei === undefined || job.imei === null) {
          job.imei = ''
          this.logDialogLog += 'IMEI number not found\n'
        } else {
          this.logDialogLog += 'IMEI number = ' + job.imei + '\n'
        }
        let doc = job.number
        let val = job
        this.logDialogLog += JSON.stringify(val) + '\n'
        try {
          for (let template in job.template) {
            this.logDialogLog += 'Looping through templates. Current template = ' + template + '\n'
            for (let item in job.template[template].items) {
              let image = job.template[template].items[item].image
              let imageName = job.template[template].items[item].imageName
              if (image && !imageName) {
                let imageObj = await this.uploadImage(job, image)
                job.template[template].items[item].image = imageObj.ref
                job.template[template].items[item].imageName = imageObj.name
                let updateSuccess = await this.updateLocalJob(job, job.element)
                if (updateSuccess) {
                  let deleteImageStatus = await this.deleteImageFromDB(image)
                  if (!deleteImageStatus) {
                    throw new Error('Could not remove images')
                  }
                } else {
                  throw new Error('Could not save state')
                }
              }
            }
          }
        } catch (error) {
          this.logDialogLog += error.message + '\n'
          this.sendDebugLog()
          this.snackbar = true
          this.snackbarText = 'Failed to complete step 1 - Job not uploaded'
          this.sending = false
          return
        }
        const clean = (object) => {
          Object
            .entries(object)
            .forEach(([k, v]) => {
              if (v && typeof v === 'object') {
                clean(v)
              }
              if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined) {
                if (Array.isArray(object)) {
                  object.splice(k, 1)
                } else {
                  delete object[k]
                }
              }
            })
          return object
        }
        let template = await clean(job.template || [])
        const obj = {
          Date: job.Date,
          JobNo: job.JobNo,
          Customer: job.Customer,
          imei: job.imei,
          template: template,
          unscheduled: job.unscheduled,
          Vehicle: job.vehicle,
          vehicle: job.reg ? job.reg : '',
          CompletedDate: job.CompletedDate,
          startTime: job.startTime || null,
          endTime: job.endTime || null,
          notes: job.notes || null,
          chargeable: job.chargeable || null
        }
        fireStore.collection('Jobs/').doc(doc).collection('CompletedJobs').doc()
        .set(obj)
        .then(() => {
          fireStore.collection('Jobs/').doc(doc).update({Status: 2, CompletedDate: job.CompletedDate, notes: job.notes || null, chargeable: job.chargeable || null})
          // Data has been successful so safe to remove from IDB
          dbPromise().then(function (db) {
            let tx = db.transaction('outbox', 'readwrite')
            let outboxStore = tx.objectStore('outbox')
            outboxStore.delete(parseInt(job.element))
          })
          .then(() => {
            this.jobs.splice(jobIndex, 1)
            this.logDialogInfo = 'Upload Complete'
            this.snackbar = true
            this.snackbarText = 'Finished Sending'
            this.sending = false
            this.sendDebugLog()
          })
          .catch((error) => {
            this.logDialogLog += error.message + '\n'
            this.snackbar = true
            this.snackbarText = 'Failed to complete step 3 - Job not uploaded'
            this.sending = false
            this.sendDebugLog()
          })
        })
        .catch((error) => {
          this.logDialogLog += error.message + '\n'
          this.snackbar = true
          this.snackbarText = 'Failed to complete step 2 - Job not uploaded'
          this.sending = false
          this.sendDebugLog()
        })
      })
      //   for (let template in val.template) {
      //     this.logDialogLog += 'Looping through templates. Current template = ' + template + '\n'
      //     val.template[template].items.map((obj, item) => {
      //       promises.push(new Promise((resolve, reject) => {
      //         const thisItem = val.template[template].items[item]
      //         if (thisItem.image !== '') {
      //           toDelete.push(thisItem.image)
      //           dbPromise().then(db => {
      //             let tx = db.transaction('imageStore')
      //             let imageStore = tx.objectStore('imageStore')
      //             return (imageStore.get(thisItem.image))
      //           })
      //           .then((image) => {
      //             if (image !== undefined) {
      //               // Prepare image for sending
      //               let bytes = image.image
      //               let ref = storage.ref(job.JobNo + '/' + image.name)
      //               this.logDialogLog += 'Image found. Image name = ' + image.name + '\n'
      //               this.logDialogLog += 'Sending image\n'
      //               // Send image
      //               console.info('Sending image')
      //               ref.putString(bytes, 'data_url', {cacheControl: 'only-if-cached'})
      //               .then((snapshot) => {
      //                 this.logDialogLog += 'Image ' + image.name + ' uploaded\n'
      //                 job.template[template].items[item].image = snapshot.downloadURL
      //                 job.template[template].items[item].imageName = image.name
      //                 console.log('uploaded')
      //                 resolve('resolved')
      //                 // Image has been successful so safe to remove from IDB
      //                 // On successful removal change flag and check if anything is still sending
      //               })
      //               .catch((error) => {
      //                 this.logDialogLog += 'Image ' + image.name + ' failed to upload\n'
      //                 console.log('rejected')
      //                 console.log(error)
      //                 reject('rejected')
      //               })
      //             }
      //           })
      //         } else {
      //           resolve('no image')
      //           this.logDialogLog += 'No image to upload\n'
      //         }
      //       }))
      //     })
      //   }
      //   Promise.all(promises)
      //   .then(async value => {
      //     this.logDialogLog += 'Image upload complete\n'
      //     if (value.indexOf('rejected') > -1) {
      //       this.logDialogLog += 'One or more images failed to upload. Stopping upload\n'
      //       this.snackbarText = 'Image upload failed. Please try again'
      //       this.snackbar = true
      //       return
      //     }
      //     const clean = (object) => {
      //       Object
      //         .entries(object)
      //         .forEach(([k, v]) => {
      //           if (v && typeof v === 'object') {
      //             clean(v)
      //           }
      //           if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined) {
      //             if (Array.isArray(object)) {
      //               object.splice(k, 1)
      //             } else {
      //               delete object[k]
      //             }
      //           }
      //         })
      //       return object
      //     }
      //     let template = await clean(job.template || [])
      //     this.logDialogLog += JSON.stringify(template)
      //     const obj = {
      //       Date: job.Date,
      //       JobNo: job.JobNo,
      //       Customer: job.Customer,
      //       imei: job.imei,
      //       template: template,
      //       unscheduled: job.unscheduled,
      //       Vehicle: job.vehicle,
      //       vehicle: job.reg ? job.reg : '',
      //       CompletedDate: job.CompletedDate,
      //       startTime: job.startTime || null,
      //       endTime: job.endTime || null
      //     }
      //     fireStore.collection('Jobs/').doc(doc).collection('CompletedJobs').doc()
      //     .set(obj)
      //     .then(() => {
      //       this.logDialogLog += 'Completed job saved in database\n'
      //       fireStore.collection('Jobs/').doc(doc).update({Status: 2, CompletedDate: job.CompletedDate})
      //       .then(ref => {
      //         this.logDialogLog += 'Status and completed date updated\n'
      //       })
      //       .catch(error => {
      //         console.log(error)
      //         this.logDialogLog += 'Job status was not updated\n'
      //       })
      //       // Data has been successful so safe to remove from IDB
      //       dbPromise().then(db => {
      //         let tx = db.transaction('outbox', 'readwrite')
      //         let outboxStore = tx.objectStore('outbox')
      //         outboxStore.delete(parseInt(job.element))
      //       })
      //       .then(() => {
      //         this.logDialogLog += 'Job removed from outbox\n'
      //         // this.getImages()
      //         for (let deleteIndex in toDelete) {
      //           dbPromise().then(db => {
      //             this.logDialogLog += 'Image deleted from storage\n'
      //             let tx = db.transaction('imageStore', 'readwrite')
      //             let imageStore = tx.objectStore('imageStore')
      //             imageStore.delete(toDelete[deleteIndex])
      //           })
      //         }
      //         this.jobs.splice(jobIndex, 1)
      //         this.logDialogInfo = 'Upload Complete'
      //         this.sendDebugLog()
      //       })
      //     })
      //     .catch(error => {
      //       console.log(error)
      //       this.logDialogLog += 'Completed job was not saved to the database\n'
      //       this.logDialogInfo = 'Upload Failed'
      //       this.sendDebugLog()
      //     })
      //   })
      //   .catch(reason => {
      //     this.logDialogLog += 'Image upload failed\n'
      //     this.logDialogLog += 'Reason: ' + reason + '\n'
      //     this.logDialogInfo = 'Upload Failed'
      //     this.sendDebugLog()
      //   })
      // })
    },
    uploadImage (job, image) {
      console.log(image)
      return dbPromise().then(function (db) {
        let tx = db.transaction('imageStore')
        let imageStore = tx.objectStore('imageStore')
        return (imageStore.get(image))
      })
      .then(async (image) => {
        this.logDialogLog += 'Sending image\n'
        if (image) {
          if (image.name === '1648904305868.jpg') {
            this.logDialogLog += image.image
            return {ref: '', name: image.name}
          }
          this.logDialogLog += 'Image found. Image name = ' + image.name + '\n'
          let bytes = image.image
          let ref = storage.ref(job.JobNo + '/' + image.name)
          let response = await ref.putString(bytes, 'data_url', {cacheControl: 'only-if-cached'})
          this.logDialogLog += 'Image ' + image.name + ' uploaded\n'
          return { ref: response, name: image.name, pathRef: ref }
        }
      })
      .then(async (snapshotObj) => {
        let downloadURL = await snapshotObj.pathRef.getDownloadURL()
        return { ref: downloadURL, name: snapshotObj.name }
      })
    },
    updateLocalJob (job, key) {
      return dbPromise().then((db) => {
        let tx = db.transaction('outbox', 'readwrite')
        let outboxStore = tx.objectStore('outbox')

        outboxStore.put(job, key)
        return tx.complete
      })
      .then(() => {
        return true
      })
      .catch(() => {
        return false
      })
    },
    deleteImageFromDB (key) {
      return dbPromise().then(function (db) {
        let tx = db.transaction('imageStore', 'readwrite')
        let imageStore = tx.objectStore('imageStore')
        imageStore.delete(key)
        return true
      })
      .catch(() => {
        return false
      })
    },
    imageCount (job) {
      let imageCount = 0
      let imagesSent = 0
      for (let template in job.template) {
        for (let item in job.template[template].items) {
          if (job.template[template].items[item].image) {
            imageCount++
            if (job.template[template].items[item].imageName) {
              imagesSent++
            }
          }
        }
      }
      return {count: imageCount, sent: imagesSent}
    },
    deleteJob (jobNumber) {
      this.logDialogTitle = 'Delete Job'
      this.logDialogInfo = 'Delete in progress'
      this.logDialogLog = ''
      this.logDialog = true
      let jobIndex = this.jobs.findIndex(jobObj => { return jobObj.number === jobNumber })
      let job = this.jobs[jobIndex]
      let val = job
      let promises = []
      for (let template in val.template) {
        this.logDialogLog += 'Looping through templates. Current template = ' + template + '\n'
        val.template[template].items.map((obj, item) => {
          promises.push(new Promise((resolve, reject) => {
            const thisItem = val.template[template].items[item]
            if (thisItem.image !== '') {
              dbPromise()
              .then(db => {
                let tx = db.transaction('imageStore', 'readwrite')
                let imageStore = tx.objectStore('imageStore')
                imageStore.delete(thisItem.image)
                this.logDialogLog += 'Image deleted from storage\n'
                resolve('deleted')
              })
              .catch(error => {
                console.log(error)
                resolve('not deleted')
              })
            } else {
              resolve('no image')
            }
          }))
        })
      }
      Promise.all(promises)
      .then(value => {
        dbPromise().then(db => {
          let tx = db.transaction('outbox', 'readwrite')
          let outboxStore = tx.objectStore('outbox')
          outboxStore.delete(parseInt(job.element))
          this.logDialogLog += 'Job data deleted\n'
          this.jobs.splice(jobIndex, 1)
          this.logDialogLog += 'Job deleted\n'
          this.logDialogInfo = 'Job deleted'
        })
      })
    },
    generateZip (jobNumber, zipCallback) {
      const zip = new JsZip()

      let job = this.jobs.find(jobObj => { return jobObj.number === jobNumber })
      zip.file('Job Data.txt', JSON.stringify(job))
      this.logDialogLog += 'Job data added to zip\n'
      let val = job
      let promises = []
      for (let template in val.template) {
        val.template[template].items.map((obj, item) => {
          promises.push(new Promise((resolve, reject) => {
            const thisItem = val.template[template].items[item]
            const title = thisItem.title
            if (thisItem.image !== '') {
              dbPromise().then(db => {
                let tx = db.transaction('imageStore')
                let imageStore = tx.objectStore('imageStore')
                return (imageStore.get(thisItem.image))
              })
              .then((image) => {
                if (image !== undefined) {
                  // Prepare image for sending
                  let bytes = image.image
                  zip.file(template + '-' + title + '.jpg', bytes.replace('data:image/jpeg;base64,', ''), { base64: true })
                  this.logDialogLog += title + ' image added to zip file\n'
                  resolve('image')
                }
              })
            } else if (thisItem.note) {
              this.logDialogLog += template + '-' + title + ' is a note, adding as text file\n'
              zip.file(template + '-' + title + '.txt', thisItem.note)
              resolve('note')
            } else {
              this.logDialogLog += template + '-' + title + ' is not a note or an image, may be an optional item which was skipped\n'
              resolve('no image')
            }
          }))
        })
      }
      Promise.all(promises)
      .then(value => {
        zip.generateAsync({type: 'blob'})
        .then(function (content) {
          let zipName = ''
          if (job.JobNo) {
            zipName = job.JobNo
          } else if (job.reg) {
            zipName = job.reg
          } else {
            zipName = moment().format('X')
          }
          zipCallback(content, zipName)
          // saveAs(content, zipName + '.zip')
        })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// Outbox.vue?5d2dad62